require("././animate.css");


//////////////////
// WEBPACK FOOTER
// animate.css (bower component)
// module id = 467
// module chunks = 0